import { useRateScreenerMetrics } from '@/api/queries'
import { KpiCard } from '@/features/cockpit/KpiCard'
import { compactNumber, percent } from '@/lib/format'

export function RateScreenerKpi({ className }: { className?: string }) {
  const { data, isLoading } = useRateScreenerMetrics()

  return (
    <KpiCard
      className={className}
      title="RateScreener · last 24h"
      loading={isLoading}
      headline={[
        { value: data ? compactNumber(data.totalRequests) : '–', label: `requests${data ? ` · ${data.finishedRate.toFixed(0)}% finished` : ''}` },
        { value: data?.customers ?? '–', label: 'customers' },
      ]}
      stats={[
        { label: 'Success', value: percent(data?.successRatio, 1), tone: data ? (data.successRatio >= 95 ? 'ok' : 'warn') : undefined },
        { label: 'Success incl. unfinished', value: percent(data?.successRatioWithUnfinished, 1), tone: data ? (data.successRatioWithUnfinished >= 95 ? 'ok' : 'warn') : undefined },
        { label: 'Open', value: percent(data?.openRatio, 1), tone: 'info' },
        { label: 'Closed', value: percent(data?.closedRatio, 1), tone: data ? (data.closedRatio >= 30 ? 'danger' : 'info') : undefined },
      ]}
    />
  )
}
